module.exports = __webpack_public_path__ + "static/media/image4.d1e4e41c.webp";